import { duplicateBusinessProfileError } from 'lib/common/messages';
import addMessage from 'action-creators/messaging/add-message';

const businessProfileExistsError = () => (addMessage(duplicateBusinessProfileError));
export default businessProfileExistsError;
